import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

export default class PaypalResource extends AuthenticatedResource  {
    static urlRoot = 'profile/:organization_slug/paypal' as const;

    readonly id: number | undefined = undefined;

    pk() {
        return this.id?.toString();
    }
}